import { render, staticRenderFns } from "./face_data_imgs.vue?vue&type=template&id=3c7823b5&scoped=true&"
import script from "./face_data_imgs.vue?vue&type=script&lang=js&"
export * from "./face_data_imgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7823b5",
  null
  
)

export default component.exports